import { Configuration } from "@interface48/api";
import { getUserManager } from "../../auth";

export const getApiConfiguration = (includeAccessToken: boolean = true): Promise<Configuration> => {
  return new Promise<Configuration>((resolve, reject) => {
    if (includeAccessToken) {
      getUserManager()
        .getUser()
        .then(user => {
          if (!user) {
            reject("User could not be resolved.");
          } else {
            resolve({
              accessToken: user.access_token,
              basePath: window.location.origin,
            } as Configuration);
          }
        })
        .catch(error => {
          reject(`The following error occurred upon attempting to resolve the Configuration: ${error}`);
        });
    } else {
      resolve({
        basePath: window.location.origin,
      } as Configuration);
    }
  });
};
